import Default from "../Pages/Dashboard/Default";
import Analytics from "../Pages/Dashboard/Analytics";
import ViewGeneralSettings from "../Pages/GeneralSettings/ViewGeneralSettings";
import AddGeneralSettings from "../Pages/GeneralSettings/AddGeneralSettings";
import EditGeneralSettings from "../Pages/GeneralSettings/EditGeneralSettings";
import ViewRoles from "../Pages/RoleManagement/ViewRoles";
import AddRole from "../Pages/RoleManagement/AddRole";
import EditRole from "../Pages/RoleManagement/EditRole";
import ViewEmployees from "../Pages/EmployeeManagement/ViewEmployees";
import AddEmployee from "../Pages/EmployeeManagement/AddEmployee";
import EditEmployee from "../Pages/EmployeeManagement/EditEmployee";
import ViewBystanders from "../Pages/BystanderManagement/ViewBystanders";
import AddBystander from "../Pages/BystanderManagement/AddBystander";
import EditBystander from "../Pages/BystanderManagement/EditBystander";
import ViewPatients from "../Pages/PatientManagement/ViewPatients";
import ViewBookings from "../Pages/BookingManagement/ViewBookings";
import PayoutManagement from "../Pages/BookingManagement/PayoutManagement";
import PayoutDetails from "../Pages/BookingManagement/PayoutDetails";
import ViewTimingSettings from "../Pages/TimingSettings/ViewTimingSettings";
import AddTimingSettings from "../Pages/TimingSettings/AddTimingSettings";
import EditTimingSettings from "../Pages/TimingSettings/EditTimingSettings";
import ExpenseManagement from "../Pages/ExpenseManagement/ExpenseManagement";

import ServiceReport from "../Pages/FinancialReports/ServiceReport";
import ProfitabilityReport from "../Pages/FinancialReports/ProfitabilityReport";
import BystanderPerformanceReport from "../Pages/FinancialReports/BystanderPerformanceReport";
import PatientInsightsReport from "../Pages/FinancialReports/PatientInsightsReport";

export const routes = [
    { path: `${process.env.PUBLIC_URL}/dashboard`, element: <Analytics />, permission: 'dashboard.view' },

    { path: `${process.env.PUBLIC_URL}/service_report`, element: <ServiceReport />, permission: 'service-report.view' },
    { path: `${process.env.PUBLIC_URL}/profitability_report`, element: <ProfitabilityReport />, permission: 'profitability-report.view' },
    { path: `${process.env.PUBLIC_URL}/bystander_performance_report`, element: <BystanderPerformanceReport />, permission: 'bystander-performance-report.view' },
    { path: `${process.env.PUBLIC_URL}/patient_insights_report`, element: <PatientInsightsReport />, permission: 'patient-insights-report.view' },
    
    { path: `${process.env.PUBLIC_URL}/general_settings`, element: <ViewGeneralSettings />, permission: 'general-settings.view' },
    { path: `${process.env.PUBLIC_URL}/add_general_settings`, element: <AddGeneralSettings />, permission: 'general-settings.add' },
    { path: `${process.env.PUBLIC_URL}/edit_general_settings`, element: <EditGeneralSettings />, permission: 'general-settings.edit' },

    // Role Management
    { path: `${process.env.PUBLIC_URL}/role`, element: <ViewRoles />, permission: 'role-management.view' },
    { path: `${process.env.PUBLIC_URL}/add_role`, element: <AddRole />, permission: 'role-management.add' },
    { path: `${process.env.PUBLIC_URL}/edit_role`, element: <EditRole />, permission: 'role-management.edit' },

    // Employee Management
    { path: `${process.env.PUBLIC_URL}/employee`, element: <ViewEmployees />, permission: 'employee-management.view' },
    { path: `${process.env.PUBLIC_URL}/add_employee`, element: <AddEmployee />, permission: 'employee-management.add' },
    { path: `${process.env.PUBLIC_URL}/edit_employee`, element: <EditEmployee />, permission: 'employee-management.edit' },

    // Bystander Management
    { path: `${process.env.PUBLIC_URL}/bystander`, element: <ViewBystanders />, permission: 'bystander-management.view' },
    { path: `${process.env.PUBLIC_URL}/add_bystander`, element: <AddBystander />, permission: 'bystander-management.add' },
    { path: `${process.env.PUBLIC_URL}/edit_bystander`, element: <EditBystander />, permission: 'bystander-management.edit' },

    // Patient Management
    { path: `${process.env.PUBLIC_URL}/patient`, element: <ViewPatients />, permission: 'patient-management.view' },

    // Booking Management
    { path: `${process.env.PUBLIC_URL}/booking`, element: <ViewBookings />, permission: 'booking-management.view' },
    { path: `${process.env.PUBLIC_URL}/payout_management`, element: <PayoutManagement />, permission: 'payout-management.view' },
    { path: `${process.env.PUBLIC_URL}/payout_details`, element: <PayoutDetails />, permission: 'payout-management.view' },

    // Timing Settings
    { path: `${process.env.PUBLIC_URL}/timing_settings`, element: <ViewTimingSettings />, permission: 'timing-settings.view' },
    { path: `${process.env.PUBLIC_URL}/add_timing_settings`, element: <AddTimingSettings />, permission: 'timing-settings.add' },
    { path: `${process.env.PUBLIC_URL}/edit_timing_settings`, element: <EditTimingSettings />, permission: 'timing-settings.edit' },
    
    // Expense
    { path: `${process.env.PUBLIC_URL}/expense`, element: <ExpenseManagement />, permission: 'expense-management.view' },
]